import { PieChart, Pie, Cell, Tooltip, Legend } from 'recharts';

const inventoryStateColors = {
  Installer: "#4CAF50",     // Green – Active work/deployment
  Warehouse: "#FFB300",     // Amber – Storage/holding state
  Company: "#6A1B9A",       // Purple – External party
  Vehicle: "#F06292",       // Pink – On the move
  Gps: "#009688",           // Teal – Device-centric status
  Lost: "#E53935",          // Bright Red – Critical
  Scrap: "#757575",         // Dark Gray – End of life
  Supplier: "#1976D2"       // Deep Blue – External source
};

function PieChartElement({ chartData }) {
  return (
    <div className="d-flex justify-content-center">
        <PieChart width={400} height={400}>
          <Pie
            data={chartData}
            cx="50%"
            cy="50%"
            label
            outerRadius={150}
            dataKey="value">
            {chartData.map((entry, index) => (
              <Cell key={`cell-${index}`} className='mx-2' fill={inventoryStateColors[entry?.name] || "#000000"} />
            ))}
          </Pie>
          <Tooltip />
          <Legend />
        </PieChart>
      </div>
  );
}

export default PieChartElement;